import React from 'react';
import { EVENT_WARNING_TYPES, WARNING_SCOPE } from '../../../constants/EventWarningTypes';
import { getEventWarningWithScope } from '../../../services/calendarWarningService';

const APPRAISAL_DETAIL_STATUS_MAP = {
  [EVENT_WARNING_TYPES.EVENT_PENDING_REVIEW]: 'Pending ISACA approval',
  [EVENT_WARNING_TYPES.EVENT_PENDING_SUBMISSION]: 'Pending ATL submission'
};

/**
 * @typedef {object} AppraisalDetailStatusProps
 * @property {Array<*>} [warningTypes]
 */

/**
 * @param {AppraisalDetailStatusProps} props
 */
const AppraisalDetailStatus = props => {
  const { warningTypes = [] } = props;

  const appraisalDetailStatusWarning = getEventWarningWithScope(
    warningTypes,
    WARNING_SCOPE.APPRAISAL_DETAIL
  );
  if (!appraisalDetailStatusWarning) {
    return null;
  }

  const appraisalDetailStatus = APPRAISAL_DETAIL_STATUS_MAP[appraisalDetailStatusWarning];

  return <div className='bold'>Appraisal Details Status: {appraisalDetailStatus}</div>;
};

export default AppraisalDetailStatus;
